<div class="driver-status-filters">
  <fm-button-toggle-group
    class="driver-status-filters__toggle-buttons"
    [value]="driverStatusFilter"
    (selectionChanged)="onFilterChange($event)"
    (selectionCleared)="selectionCleared()"
  >
    <fm-button-toggle
      iconName="ic-wtd-driving"
      [value]="EDriverWorkingState.Drive"
      tooltip="Driving"
      i18n-tooltip="@@S_TACHO_STATUS_DRIVING"
      a7s-id="live-map-selection-panel-driver-list-filter-driving"
    >
    </fm-button-toggle>
    <fm-button-toggle
      iconName="ic-wtd-other-work"
      [value]="EDriverWorkingState.Work"
      tooltip="Other Work"
      i18n-tooltip="@@S_TACHO_STATUS_OTHER_WORK"
      a7s-id="live-map-selection-panel-driver-list-filter-other-work"
    >
    </fm-button-toggle>
    <fm-button-toggle
      iconName="ic-wtd-availability"
      [value]="EDriverWorkingState.Available"
      tooltip="Period Of Availability"
      i18n-tooltip="@@S_TACHO_STATUS_AVAILABLE"
      a7s-id="live-map-selection-panel-driver-list-filter-availability"
    >
    </fm-button-toggle>
    <fm-button-toggle
      iconName="ic-wtd-resting"
      [value]="EDriverWorkingState.Rest"
      tooltip="Resting"
      i18n-tooltip="@@S_TACHO_STATUS_RESTING"
      a7s-id="live-map-selection-panel-driver-list-filter-resting"
    >
    </fm-button-toggle>
  </fm-button-toggle-group>

  <fm-button-toggle
    class="driver-status-filters__toggle-buttons"
    iconName="ic-wtd-break-due"
    tooltip="drivers with break due in 15 minutes or less"
    i18n-tooltip="@@S_TACHO_FILTER_BREAK"
    [isSelected]="isDriverBreakDueFilterSelected"
    (selected)="onIsDriverBreakDueFilterSelectedChange($event)"
    a7s-id="live-map-selection-panel-driver-list-filter-break-due"
  >
  </fm-button-toggle>
</div>
<div class="driver-list-order">
  <fm-radio-group
    class="driver-status-order__radio-group"
    [value]="driverStatusSortType"
    (valueChange)="onStatusSortTypeChange($event)"
    name="driver-list-order"
  >
    <label class="driver-status-order__label" i18n="@@S_TACHO_ORDER_BY">Order By:</label>
    <fm-radio-button
      id="rdo-driver-status-order-driver"
      i18n="@@S_TACHO_ORDER_BY_DRIVER"
      [value]="EDriverStatusSortType.DriverName"
      a7s-id="live-map-selection-panel-driver-list-order-by-driver"
      >Driver</fm-radio-button
    >
    <fm-radio-button
      id="rdo-driver-status-order-start-time"
      i18n="@@S_TACHO_ORDER_BY_START_TIME"
      [value]="EDriverStatusSortType.StartTime"
      a7s-id="live-map-selection-panel-driver-list-order-by-start-time"
      >Start Time</fm-radio-button
    >
  </fm-radio-group>
</div>
<div *ngIf="isDriverPlannerPageAllowed" class="driver-status-panel__list-header">
  <button mat-button componentStyle="tertiary" i18n="@@S_TACHO_DP_TITLE" (click)="onDriverPlannerButtonClick()">Driver Planner</button>
</div>
<hr class="driver-status-panel__separator" />
<div class="driver-status-panel__driver-list" *ngIf="driverStatusData.length > 0; else noVehicles">
  <ng-container *ngFor="let driverStatus of driverStatusData; let lastSeparator = last">
    <fm-driver-status-card
      [driverStatus]="driverStatus"
      (highlightMarker)="onHighlightMarker($event)"
      (removeMarkerHighlight)="onRemoveMarkerHighlight()"
      (openDriverStatusContextMenu)="onOpenDriverStatusContextMenu($event)"
      (triggerZoomTo)="zoomToPosition($event)"
    >
    </fm-driver-status-card>
    <hr [ngClass]="{ last: lastSeparator }" class="driver-status-panel__separator" />
  </ng-container>
</div>

<ng-template #noVehicles>
  <fm-no-vehicle-selected
    *ngIf="driverStatusFilter === null && !isDriverBreakDueFilterSelected"
    displayMessage="No vehicles with tachograph data selected"
    i18n-displayMessage="@@S_TACHO_NO_VEHICLES_NO_SELECTION"
    (selectVehiclesClicked)="onSelectVehiclesClicked()"
  ></fm-no-vehicle-selected>
  <div *ngIf="driverStatusFilter !== null || isDriverBreakDueFilterSelected">
    <div class="driver-status-empty">
      <mat-icon svgIcon="ic-no-drivers-match-filter" class="driver-status-empty__icon mat-icon-size-xl"></mat-icon>
    </div>
    <div class="driver-status-empty__text">
      <span i18n="@@S_DRIVER_STATUS_EMPTY">No drivers match this filter.</span>
      <span i18n="@@S_DRIVER_STATUS_FILTER_HELP">Use the controls above to change the filter.</span>
    </div>
  </div>
</ng-template>
